import { AaSigninReq } from 'app/bff/models/aa/aaSignin';
import { AaOtpSendcodeReq, AaOtpSendcodeResp } from 'app/bff/models/aa/aaOtpSendcode';
import { AaOtpVerifyReq } from 'app/bff/models/aa/aaOtpVerify';
import { MbUpdateinfoReq } from 'app/bff/models/mb/mbUpdateinfo';
import { ROUTES } from 'app/core/router/paths';
import { ProcessStepCodesEnum } from 'app/features/Member/Settings/Mobile/types';
import { FormValues as SetupFormValues } from 'app/features/Member/Settings/Mobile/Setup/types';

// State type
export interface MobileState {
  process: ProcessState;
}

interface ProcessState {
  accessibleSteps: ProcessStepCodesEnum[];
  setup: {
    data?: SetupFormValues;
    otpAuth: {
      mobile?: AaOtpSendcodeResp;
    };
  };
}
// ::: End

// Actions type constant
export const MEMBER_SETTING_MOBILE__SET_ACCESSIBLE_STEP = 'MEMBER_SETTING_MOBILE__SET_ACCESSIBLE_STEP';
export const MEMBER_SETTING_MOBILE__AUTH_PASS_PHRASE = 'MEMBER_SETTING_MOBILE__AUTH_PASS_PHRASE';
export const MEMBER_SETTING_MOBILE__SAVE_SETUP_PAGE_DATA = 'MEMBER_SETTING_MOBILE__SAVE_SETUP_PAGE_DATA';
export const MEMBER_SETTING_MOBILE__SEND_MOBILE_OTP = 'MEMBER_SETTING_MOBILE__SEND_MOBILE_OTP';
export const MEMBER_SETTING_MOBILE__SEND_MOBILE_OTP_DONE = 'MEMBER_SETTING_MOBILE__SEND_MOBILE_OTP_DONE';
export const MEMBER_SETTING_MOBILE__AUTH_MOBILE_OTP = 'MEMBER_SETTING_MOBILE__AUTH_MOBILE_OTP';
export const MEMBER_SETTING_MOBILE__SETUP_MOBILE = 'MEMBER_SETTING_MOBILE__SETUP_MOBILE';
export const MEMBER_SETTING_MOBILE__UPDATE_CACHE = 'MEMBER_SETTING_MOBILE__UPDATE_CACHE';
export const MEMBER_SETTING_MOBILE__RESET_CACHE = 'MEMBER_SETTING_MOBILE__RESET_CACHE';
// ::: End

// Action creators type
export interface SetAccessibleStepAction {
  type: typeof MEMBER_SETTING_MOBILE__SET_ACCESSIBLE_STEP;
  payload: {
    step: ProcessStepCodesEnum;
  };
}

export interface AuthPassPhraseAction {
  type: typeof MEMBER_SETTING_MOBILE__AUTH_PASS_PHRASE;
  payload: {
    args: AaSigninReq;
  };
}

export interface SaveSetupPageDataAction {
  type: typeof MEMBER_SETTING_MOBILE__SAVE_SETUP_PAGE_DATA;
  payload: {
    data: SetupFormValues;
  };
}

export interface SendMobileOTPAction {
  type: typeof MEMBER_SETTING_MOBILE__SEND_MOBILE_OTP;
  payload: {
    args: AaOtpSendcodeReq;
    redirectRoute?: ROUTES;
  };
}

export interface SendMobileOTPDoneAction {
  type: typeof MEMBER_SETTING_MOBILE__SEND_MOBILE_OTP_DONE;
  payload: {
    response: AaOtpSendcodeResp;
  };
}

export interface AuthMobileOTPAction {
  type: typeof MEMBER_SETTING_MOBILE__AUTH_MOBILE_OTP;
  payload: {
    authMobileOTPArgs: AaOtpVerifyReq;
    setupMobileArgs: MbUpdateinfoReq;
  };
}

export interface SetupMobileAction {
  type: typeof MEMBER_SETTING_MOBILE__SETUP_MOBILE;
  payload: {
    args: MbUpdateinfoReq;
  };
}

export interface UpdateCacheAction {
  type: typeof MEMBER_SETTING_MOBILE__UPDATE_CACHE;
  payload: {
    cache: MobileState;
  };
}

export interface ResetCacheAction {
  type: typeof MEMBER_SETTING_MOBILE__RESET_CACHE;
}

export type MobileActions =
    SetAccessibleStepAction
  | AuthPassPhraseAction
  | SaveSetupPageDataAction
  | SendMobileOTPAction
  | SendMobileOTPDoneAction
  | AuthMobileOTPAction
  | SetupMobileAction
  | UpdateCacheAction
  | ResetCacheAction;
// ::: End
